import { Pipe, PipeTransform } from '@angular/core';

import { FormatDatePipe } from './format-date.pipe';

type FormatDatePipeValue = Date | number | null | string | undefined;

@Pipe({
  name: 'formatDateUtc',
  pure: true,
})
export class FormatDateUtcPipe implements PipeTransform {
  private readonly formatDatePipe = new FormatDatePipe();

  transform(value: FormatDatePipeValue, format?: string | undefined): string {
    const preFormattedValue = this.formatDatePipe.transform(value, format);

    return preFormattedValue ? `${preFormattedValue} UTC` : '';
  }
}
